/* eslint-disable */
// Some Important Docs
//https://www.codingdeft.com/posts/react-usestate-array/

import moment from "moment";
import { APIURL, LOGINURL, PLANNINGURL, SCHEDULINGURL, MEDIAURL, FILEURL, CMSURL, PAGEURL, GetHeader, RECONSILEURL, USERURL, FILETYPEURL, CONTRACTURL, BOOKINGURL, DATAMIGRATIONURL, BILLINGURL, BOOKINGSUMMARYURL, LOCALSTORAGE_KEY, LOGGERURL, MONETIZATION, ENTITYNAME, WORKORDERURL, LIVEEVENTURL, MANAGECONTENTURL, REPORTSURL, OTTURL, AMAZONMMCMEFXML, SERVERHEALTHURL, ApplicationConfigurationKeys, CONFIGURL, RAIL_STATUS, TRANSLATORURL, DASHBOARDURL, ROLETYPE, INGESTION_MODULETYPES, DELETELOGURL, IMDBURL, THIRDPARTYAPIURL, COLUMNSTYPE, APPCONFIGURL, get_APIURL, SECONDARYEVENTURL, FILEBUCKETURL, DELETEPROGRAMSCHEDULEDRAFTURL, INGESTIONLOGURL, MAMASSETURL, SOCIAL_MEDIA_URL, BOSS_ASSISTANT_URL, DAI_URL, NOTIFICATION_URL, BUCKET_CONFIGURATION_URL, STARHUB_EXPORT_URL, STARHUB_IMPORT_URL, STARTHUB_TRAILER_WORKFLOW, MAIL_URL, LOGDATAURL, LOGDASHBOARDURL, VOD_URL, DEEPARCHIVE_URL, STARHUB_MIGRATION_URL, TOAST_TYPES, LIVETOVOD_URL, TMDBURL } from "../constant/constant";
import { utility } from "../utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import ToastNotification from "../../components/ToastNotification";

//default args
let defaultArgs = {
  // MULTIPLE QUERRY EX: [ ['SID', '>', '0'], ['SID', '>', '0'], ['SID', '>', '0']  ]
  // SINGLE QUERRY EX: ['SID', '>', '0']
  query: [],
  // SORT ASC EX: { SID : 1 }
  // SORT DESC EX: { SID : -1 }
  // MULTIPLE SORTS EX: { SID : 1, DATE : -1 }
  sort: { SID: 1 },
  // 1 MEANS FIRST PAGE, 2 MEANS 2 PAGE
  page: null,
  // NO. OF ITEMS PER PAGE
  perPage: null,
  //ARCHIVE KEY
  archive: false
}

const lang = useTranslation();

//use getEntitiesWithSearch instead
export async function getData(entityname, args = defaultArgs) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,

    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = get_APIURL(entityname) + 'getEntities/' + entityname;
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

//get entities function with search for server side search
export async function getEntitiesWithSearch(entityname, args = defaultArgs, columns, searchText, filters) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      filters: filters
    };

    if (entityname == ENTITYNAME.Users) {
      const user = utility.getValue(LOCALSTORAGE_KEY.userData);
      if (user && user.RoleType) {
        finalData.query = [...finalData.query, ["RoleType.ID", ">=", user.RoleType.ID]]
      }
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = get_APIURL(entityname) + 'getEntitiesWithSearch/' + entityname;
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();



    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getEntitiesWithSearchAndProjection(entityname, args = defaultArgs, columns, selectedColuns, searchText) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      selectedColuns: selectedColuns || []
    };

    if (entityname == ENTITYNAME.Users) {
      const user = utility.getValue(LOCALSTORAGE_KEY.userData);
      if (user && user.RoleType) {
        finalData.query = [...finalData.query, ["RoleType.ID", ">=", user.RoleType.ID]]
      }
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = get_APIURL(entityname) + 'getEntitiesWithSearchAndProjection/' + entityname;
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    // if(data && data.isValidToken == false){
    //ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Session Expired. Please login again" });
    // }
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}


export async function getNonLinearPlanning(payload) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      data: payload
    }
    const FINALURL = PLANNINGURL().BASEURL + 'getNonLinearPlanning'

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getLinearPlanning(payload) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      data: payload
    }
    const FINALURL = PLANNINGURL().BASEURL + 'getLinearPlanning'

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getSeriesTimeLineData(payload) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      data: payload
    }
    const FINALURL = PLANNINGURL().BASEURL + 'getSeriesTimeLineData'

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getFormData(entityname, userId) {

  utility.checkSessionExpire();

  try {
    const FINALURL = APIURL().BASEURL + 'formData/' + entityname;
    // console.log(userId);
    const finalData = {
      data: userId ? userId : null
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const resData = await response.json();
    if (resData.success) {
      console.log(resData);
      return resData.data.sort((a, b) => a.sequence - b.sequence).filter((x) => x.type != COLUMNSTYPE.hidden);
    }
    // If it success return other code otherwise check token expire or not
    utility.checkTokenExpire(resData);
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getEntity(entityname, SID, lookup) {
  // entityname - name of the collection you want to recieve data
  // SID - to recieve only data which has SID ex: SID = 12
  // lookup - to get link data stored in another table ex: {
  //   link_collection:'ott_assets',
  //   link_field:'ott_assets'
  // }

  utility.checkSessionExpire();

  try {
    const FINALURL = get_APIURL(entityname) + 'getEntity/' + entityname;
    let finalData = {
      query: ['SID', '=', parseInt(SID)],
      lookup: lookup
    }
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }

    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}


export async function getEntityfromAssestID(entityname, AssestID, lookup) {
  // entityname - name of the collection you want to recieve data
  // SID - to recieve only data which has SID ex: SID = 12
  // lookup - to get link data stored in another table ex: {
  //   link_collection:'ott_assets',
  //   link_field:'ott_assets'
  // }

  utility.checkSessionExpire();

  try {
    const FINALURL = APIURL().BASEURL + 'getEntity/' + entityname;
    let finalData = {
      query: ['AssetId', '=', AssestID],
      lookup: lookup
    }
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }

    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getDataLookup(entityname, args = defaultArgs, localStorageKey = '') {

  utility.checkSessionExpire();

  try {
    let dataLookup = utility.getValue(entityname);
    if (dataLookup != null && dataLookup?.data?.length > 0) return dataLookup;

    console.log(entityname + " feching from server");
    let finalData = {
      query: args.query,
      sort: args.sort,
      page: args.page,
      perPage: args.perPage
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = get_APIURL(entityname) + 'getEntities/' + entityname;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.success) {
      //setting in loacl straoge
      let key = localStorageKey == '' ? entityname : localStorageKey
      utility.setValue(key, data);
      return data;
    }
    console.log(data);
    utility.checkTokenExpire(data)

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getValidChannels() {

  utility.checkSessionExpire();

  try {

    var dataLookup = utility.getValue(LOCALSTORAGE_KEY.userValidChannels);
    if (dataLookup != null) return dataLookup;

    const user = utility.getValue(LOCALSTORAGE_KEY.userData);

    let finalData = {
      user: user || {}
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = USERURL().BASEURL + 'getValidChannels';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    utility.setValue("userValidChannels", data);
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getDataLookupData(entityname, args = defaultArgs, localStorageKey = '') {

  var res = await getDataLookup(entityname, args, localStorageKey);

  return res.data;

}

export async function saveData(entityname, saveData) {

  saveData = utility.prepareSaveData(entityname, saveData)

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = get_APIURL(entityname) + "saveData/" + entityname;

    //prepare data
    const finalData = {
      data: saveData,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }
    return responseData;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function deleteData(entityname, id, columnName = 'SID') {

  try {
    const finalData = {
      columnName: columnName
    }
    let Finalinit = { ...GetHeader("DELETE"), "body": JSON.stringify(finalData) };

    const response = await fetch(`${APIURL().BASEURL}${entityname}/${id}`, Finalinit);
    const resData = await response.json();

    return resData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function bulkUpdate(entityname, updateDataArray, query = null) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    //prepare data
    const finalData = {
      data: updateDataArray,
      query: query || null,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }

    const FINALURL = APIURL().BASEURL + "bulkUpdate/" + entityname;
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }
    return responseData;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function bulkUpdateSelectedItems(entityname, selectedItems, updateData) {

  try {
    let FINALURL = APIURL().BASEURL + "bulkUpdateSelectedItems/" + entityname;

    //prepare data
    const finalData = {
      selectedItems: selectedItems,
      data: updateData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log(responseData);
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }
    return responseData;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function getAndSaveNextNumber(SID, saveData) {

  utility.checkSessionExpire();

  try {
    // http://localhost:3000/v2/data/getAndSaveNextHouseNumber/3
    const FINALURL = APIURL().BASEURL + "getAndSaveNextHouseNumber/" + SID;

    //prepare data
    const finalData = {
      data: saveData,
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    if (responseData.success) {
      return responseData;
    }
    utility.checkTokenExpire(responseData);
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function getAndSaveMaterialContentNextHouseNumber(SID, saveData) {

  utility.checkSessionExpire();

  try {
    // http://localhost:3000/v2/data/getAndSaveNextHouseNumber/3
    const FINALURL = APIURL().BASEURL + "getAndSaveMaterialContentNextHouseNumber/" + SID;

    //prepare data
    const finalData = {
      data: saveData,
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    if (responseData.success) {
      return responseData;
    }
    utility.checkTokenExpire(responseData);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function createSeriesMediaEpisodes(saveData) {

  try {
    // http://localhost:3000/v2/media/createSeriesMediaEpisodes
    const FINALURL = MEDIAURL().BASEURL + "createSeriesMediaEpisodes/";

    //prepare data
    const finalData = {
      data: saveData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function getLiveEvent(title, duration) {

  utility.checkSessionExpire();

  //title = "Live"
  //duration = in millesconds

  try {
    if (title == "" || title == undefined || duration == "" || duration == undefined) {
      return { success: false, message: "Please enter title and duration", error: "Please enter title and duration" };
    }
    const FINALURL = MEDIAURL().BASEURL + "getLiveEvent";

    //prepare data
    const finalData = {
      title: title,
      duration: duration
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function getBreakItemForSchedule(mediaCategory, mediaCategoryType, duration) {
  //mediaCategory 
  //mediaCategoryType
  //duration in millesconds

  utility.checkSessionExpire();

  try {

    const FINALURL = MEDIAURL().BASEURL + "getBreakItemForSchedule";

    //prepare data
    const finalData = {
      MediaCategory: mediaCategory,
      MediaCategoryType: mediaCategoryType,
      duration: duration
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}


export async function createSportsEvent(eventDetail) {

  try {

    const FINALURL = MEDIAURL().BASEURL + "createSportsEvent/";

    //prepare data
    const finalData = {
      data: {
        eventDetail: eventDetail,
        content: eventDetail.Content
      }
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(response);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function createSeriesSeasons(saveData) {

  try {
    // http://localhost:3000/v2/media/createSeriesSeasons
    const FINALURL = MEDIAURL().BASEURL + "createSeriesSeasons/";

    //prepare data
    const finalData = {
      data: saveData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function getMusicByMusicCategory(musicCategory, filterById = false) {

  try {

    const FINALURL = MEDIAURL().BASEURL + "getMusicByMusicCategory/";

    //prepare data
    const finalData = {
      filters: musicCategory,
      filterById: filterById
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}

export async function syncMAMDataWithMediaEpisode() {

  try {

    const FINALURL = MEDIAURL().BASEURL + "syncMAMDataWithMediaEpisode/";

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({}) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

//reconciliation
export async function saveAsRunData(saveData) {

  try {
    // http://localhost:3000/v2/data/saveProgramScheduleReconcileDTO/saveAsRunData
    const FINALURL = RECONSILEURL().BASEURL + "saveAsRunData";

    //prepare data
    const finalData = {
      data: saveData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function saveReconciliationStatus(saveData) {

  const userData = utility.getValue(LOCALSTORAGE_KEY.userData);

  try {
    // http://localhost:3000/v2/reconciliation/saveAsRunData
    const FINALURL = RECONSILEURL().BASEURL + "saveReconciliationStatus";

    //prepare data
    const finalData = {
      data: saveData,
      User: { _id: userData?._id ?? "", name: userData?.name ?? "" },
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function readAsRunData(file, channelSID) {

  try {
    const FINALURL = RECONSILEURL().BASEURL + 'readAsRunData/' + channelSID;;

    let formData = new FormData()
    formData.append('file', file);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function loadImportedAsRun(item) {

  // var item = {
  //   FromData : FromData,
  //   ToDate : ToDate,
  //   Channel : Channel
  // }

  utility.checkSessionExpire();

  try {
    let finalData = {
      data: item
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = RECONSILEURL().BASEURL + "loadImportedAsRun"
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteImportedAsRunFile(fileName) {


  try {
    const finalData = {
      data: fileName
    }

    // deleteImportedAsRun
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = RECONSILEURL().BASEURL + "deleteImportedAsRun"
    const response = await fetch(FINALURL, Finalinit);
    const resData = await response.json();

    return resData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function autoReconcilation(payload) {

  // var payload = {
  //   ScheduleDate: scheduleStart ,
  //   ScheduleEndDate: new Date(dataItem.FromDate).getTime() + offsetTime + (24 * 3600000),
  //   channelSID: dataItem.Channel.SID,
  //   isWithOutHeaders: true
  // };

  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = RECONSILEURL().BASEURL + "autoReconcilation"
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}


//planning
export async function getPlanning(payload) {

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getPlanning'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function loadPlanningMediaLibrary(searchText, filterDataItem, pagination, channels = []) {

  utility.checkSessionExpire();

  // console.log(filterDataItem);

  let finalData = {
    data: searchText,
    filter: filterDataItem,
    pagination: pagination,
    channels: channels.length > 0 ? channels.map((x) => x.SID) : []
  }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'loadPlanningMediaLibrary'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getMediaLibraryByPlanningSlot(slot_id) {

  utility.checkSessionExpire();

  console.log(slot_id);

  let finalData = {
    planningSlot_id: slot_id
  }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getMediaLibraryByPlanningSlot'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getAutoPlanningPlottingDataByPlanningSlots(payload) {

  utility.checkSessionExpire();

  console.log(payload);

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getMediaLibraryDummyScheduleByPlanningSlots'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function savePlanningSlotSchedule(data) {

  utility.checkSessionExpire();
  const userData = utility.getValue(LOCALSTORAGE_KEY.userData);

  let finalData = {
    data: data,
    user: { _id: userData?._id ?? "", name: userData?.name ?? "" },
  }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'savePlanningSlotSchedule'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}
export async function loopPlanning(fromDate, endDate, channels, dataItem) {

  // console.log(filterDataItem);
  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  let finalData = {
    fromDate: fromDate,
    endDate: endDate,
    channels: channels,
    dataItem: dataItem,
    userId: user?._id
  }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'loopPlanning'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    utility.checkTokenExpire(data);
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function savePlanning(saveData, allsegments = [], loadchildren = false, fetchSegmentFromDB = false, mediaEpisodeSID = 0, dayPart = null) {

  console.log(dayPart);

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    const FINALURL = PLANNINGURL().BASEURL + 'savePlanning';

    //prepare data
    const finalData = {
      data: saveData,
      allsegments: allsegments,
      loadchildren: loadchildren,
      user: { _id: user?._id ?? "", name: user?.name ?? "" },
      fetchSegmentFromDB: fetchSegmentFromDB,
      mediaEpisodeSID: mediaEpisodeSID,
      dayPart: dayPart
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function ReplaceProgram(newProgram, oldProgram, deleteChildren = false) {

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'replaceProgram';

    //prepare data
    const finalData = {
      newProgram: newProgram,
      oldProgram: oldProgram,
      deleteChildren: deleteChildren
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}


export async function applyRecursion(parentappointment, recursivemodel) {

  try {

    const currentUser = utility.getValue(LOCALSTORAGE_KEY.userData);

    //prepare data
    const finalData = {
      data: parentappointment,
      recursivemodel: recursivemodel,
      user: {
        name: currentUser?.name ?? "",
        _id: currentUser?._id ?? ""
      }
    }

    let FINALURL = PLANNINGURL().BASEURL + 'applyRecursion';
    if (Object.keys(recursivemodel.RepeatPattern).length > 1) {
      FINALURL = PLANNINGURL().BASEURL + 'applyRecursionWithRepeatPattern';
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function distributePlanningAcrossChannels(parentappointment, template, pullParentAppointmentFromDb = false) {

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'distributePlanningAcrossChannels';

    //prepare data
    const finalData = {
      data: {
        planningItem: parentappointment,
        planningDistributionTemplate: template,
        pullParentAppointmentFromDb: pullParentAppointmentFromDb
      }
    }

    console.log(finalData);

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function deletePlanning(obj) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    const FINALURL = PLANNINGURL().BASEURL + 'deletePlanning';
    let finalData = {
      data: {
        "_id": obj._id,
        "MediaDealRight_id": obj.MediaDealRight_id
      },
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    console.log('resource deleted...');
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function publishUnPublishLiveEvent(payload) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    const FINALURL = PLANNINGURL().BASEURL + 'publishUnPubishLiveEvent';
    let finalData = {
      data: payload,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    console.log('resource deleted...');
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}
export async function copyStrandAndPaste(obj, pasteDate, customDuration = null) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    const FINALURL = PLANNINGURL().BASEURL + 'copyStrandAndPaste';


    let finalData = {
      pasteDate: pasteDate,
      data: obj,
      customDuration: customDuration,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}
export async function deletePlanningByOptions(option, obj) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    const FINALURL = PLANNINGURL().BASEURL + 'deletePlanningByOptions';


    let finalData = {
      option: option,
      data: {
        "_id": obj._id,
        "SlotDateTime": obj.SlotDateTime,
        "RecursionParentProgramSchedule_id": obj.RecursionParentProgramSchedule_id,
        "MediaDealRight_id": obj.MediaDealRight_id,
        "MediaEpisode_id": obj.MediaEpisode_id,
        "ChannelId": obj.Channel._id
      },
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function checkCopyScheduleVadilation(payload) {
  console.log(payload);

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'checkCopyScheduleVadilation';

    let finalData = {
      data: payload
    }

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function copySchedule(payload) {
  console.log(payload);
  // {
  //   payload : {
  //     CopyFromDate : fromDate,
  //     CopyToDate : utility.addTimeToDateInMilliseconds(toDate,23,59,59,999),
  //     CopyTillDate : toDate,
  //     FromChannel : dataItem.Channel,
  //     Activity : dataItem.Activity
  // }
  // }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'copySchedule';

    let finalData = {
      data: payload
    }

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function copyPastePlanningSlots(payload) {
  console.log(payload);
  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = PLANNINGURL().BASEURL + 'copyPastePlanningSlots';

    let finalData = {
      data: payload,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function updateSegmentInPlanning(mediaEpisodeId) {

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'updateSegmentInPlanning';

    //prepare data
    const finalData = {
      data: { MediaEpisode_id: mediaEpisodeId }
    }



    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}


export async function exportPDF(payload) {

  //payload
  // {
  //     "param": {
  //         "query": {
  //             "fromDate": 1671301800000, 
  //             "toDate": 1671706599000,
  //             "channelSID": [1,2,...],
  //             }
  //     },
  //     "slotDuration":slotDuration,
  //     "planningPreference":planningPreference,
  //     "selectedColumns":selectedColumns
  // }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'exportPDF';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}
export async function exportPlanning(payload) {

  //payload
  // {
  //     "param": {
  //         "query": {
  //             "fromDate": 1671301800000, 
  //             "toDate": 1671706599000,
  //             "channelSID": [1,2,...],
  //             }
  //     },
  //     "slotDuration":slotDuration,
  //     "planningPreference":planningPreference,
  //     "selectedColumns":selectedColumns
  // }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'exportPlanning';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}


export async function exportEPG(payload) {

  //payload
  // {
  //     "param": {
  //         "query": {
  //             "fromDate": 1671301800000, 
  //             "toDate": 1671706599000,
  //             "channelSID": [1,2,...],
  //             }
  //     }
  // }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'exportEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}
//scheduling
export async function getScheduling(payload) {

  utility.checkSessionExpire();
  //payload data:
  // ScheduleDate in ms
  // channelSID

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'getScheduling'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getSchedulingHeaders(payload) {

  utility.checkSessionExpire();
  //payload data:
  // ScheduleDate in ms
  // channelSID

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'getSchedulingHeaders'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

//scheduling
export async function getAsrunData(payload) {

  utility.checkSessionExpire();
  //payload data:
  // ScheduleDate in ms
  // channelSID

  try {
    const FINALURL = RECONSILEURL().BASEURL + 'getAsrunData'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function loadSchedulingMediaLibrary(searchText, filterDataItem, payload, filterByDate, pagination, isBreak = false, commercialAssetIds = []) {

  utility.checkSessionExpire();

  let finalData = {
    data: searchText,
    filter: filterDataItem,
    payload: payload,
    filterByDate: filterByDate,
    pagination: pagination,
    isBreak: isBreak,
    commercialAssetIds: commercialAssetIds
  }

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'loadSchedulingMediaLibrary'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function loadSchedulingCompleteMediaLibrary(payload) {

  utility.checkSessionExpire();

  let finalData = {
    payload: payload,
  }

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'loadSchedulingCompleteMediaLibrary'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

//scheduling
export async function getScheduleBookedCommercial(payload) {

  utility.checkSessionExpire();
  //payload data:
  // ScheduleDate in ms
  // channelSID

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'loadBookedCommercials'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function saveScheduling(programScheduleDetailData) {

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'saveScheduling';

    //prepare data
    let finalData = {
      "ProgramScheduleDetail": programScheduleDetailData
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    console.log("SAVED DATA");
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}


export async function exportSchedule(payload) {

  //payload
  // {
  //     "automation": "PXF",
  //     "param": {
  //         "query": {
  //             "startDate": 1672312909684, 
  //             "endDate": 1671706599000,
  //             "channelSID": 1
  //             },
  //         "sort" :{ "SID": 1 },
  //         "tableName": "programschedule"
  //     }
  // }
  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    var finalPayload = {
      ...payload,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    const FINALURL = SCHEDULINGURL().BASEURL + 'exportSchedule';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalPayload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function getScheduleMAMAssetMediaReport(payload) {

  utility.checkSessionExpire();
  //payload data:
  // ScheduleDate in ms
  // channelSID

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'getScheduleMAMAssetMediaReport'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function syncMediaManagement(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MAMASSETURL().BASEURL + 'syncMediaManagement'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

//Booking
export async function loadBookingData(payload) {

  utility.checkSessionExpire();

  //Payload
  // {
  //   "channelSID":1,
  //   "BookingDate":6000,

  // }

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'loadBookingData';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function saveBooking(data, days, campaignNo, currentBookingDetails) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'saveBooking';

    //prepare data
    const finalData = {
      data: data,
      days: days,
      campaignNo: campaignNo,
      currentBookingDetails: currentBookingDetails
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function saveYearlyBooking(data, days, campaignNo, currentBookingDetails) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'saveYearlyBooking';

    //prepare data
    const finalData = {
      data: data,
      days: days,
      campaignNo: campaignNo,
      currentBookingDetails: currentBookingDetails
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function updateBookingLineNumber(data, days) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + "updateBookingLineNumber"

    //prepare data
    const finalData = {
      data: data,
      days: days
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }


}


export async function deleteBookingLine(data) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + "deleteBookingLine"

    //prepare data
    const finalData = {
      data: data
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteBookingForCommercial(payload) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + "deleteBookingForCommercial"

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function replaceBookingCommercial(payload) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + "replaceBookingCommercial"

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function getBookedDataByLineNumber(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getBookedDataByLineNumber';

    console.log(payload);

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function updateBookingSpotMakeGoodPurge(ids, makeGood, purge) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData);
  try {
    const FINALURL = BOOKINGURL().BASEURL + "updateBookingSpotMakeGoodPurge"

    //prepare data
    const finalData = {
      booking_ids: ids,
      makeGood: makeGood ?? false,
      purge: purge ?? false,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function getFirstLastBookedItemInCampaign(campaign_id) {

  utility.checkSessionExpire();

  let payload = {
    campaign_Id: campaign_id
  }

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getFirstLastBookedItemInCampaign';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

//media
export async function saveMedia(payload) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'saveMedia';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    console.log("SAVED DATA");
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function canChangeCommercialDuration(mediaEpsiode) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'canChangeCommercialDuration';

    const finalData = {
      data: mediaEpsiode
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function onChangeArchiveInSeriesSeason(payload) {

  // {
  //     "_id" : "64b138b6b15d3caeb816c3e1",
  //     "archive" : false,
  //     "entityName" : "season"
  // }

  console.log(payload);
  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    const FINALURL = MEDIAURL().BASEURL + 'onChangeArchiveInSeriesSeason';

    let finalData = {
      ...payload,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getRepeatTypeLiveEventSegment(payload) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'getRepeatTypeLiveEventSegment';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    console.log("SAVED DATA");
    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}




export async function getApplicationConfiguration() {

  try {
    const FINALURL = APPCONFIGURL().BASEURL + "getApplicationConfiguration";
    let Finalinit = { ...GetHeader() };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function uploadImage(imageData) {

  try {
    let FINALURL = FILEBUCKETURL().BASEURL + 'UploadFile';

    let formData = new FormData()
    formData.append('file', imageData)

    let Finalinit = { ...GetHeader('POST', true), body: formData };
    let response = await fetch(FINALURL, Finalinit);
    if (response.status === 413) {
      return { success: false, message: "The file you're trying to upload is too large. Please choose a smaller file." }
    }
    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message }
  }

}

export async function UploadFileInChunks(chunk, chunkIndex, totalChunks, fileName, data, uploadToken) {

  try {
    let FINALURL = FILEBUCKETURL().BASEURL + 'UploadFileInChunks';

    const formData = new FormData();
    formData.append('chunk', chunk);
    formData.append('chunkIndex', chunkIndex);
    formData.append('totalChunks', totalChunks);
    formData.append('fileName', fileName);
    formData.append('data', data);
    formData.append('uploadToken', uploadToken);

    let Finalinit = { ...GetHeader('POST', true), body: formData };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message }
  }

}

// Example payload for getReport
// {
//   "reportType": "XLSX", // can be = {"CSV","XML","XLSX"}
//   "param": {"query": ["SID","=", 3092],"sort" :{ "SID": 1 },"tableName": "programschedule"}
// }
export async function getReport(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = FILEURL().BASEURL + 'getReport';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function exportSamsungEPG(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'exportSamsungEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function exportTooberEPG(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'exportTooberEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

//cms

export async function getLayout() {

  utility.checkSessionExpire();

  try {
    const FINALURL = CMSURL().BASEURL + 'getLayout';
    let Finalinit = { ...GetHeader() };

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function getLayout3() {

  utility.checkSessionExpire();

  try {
    const FINALURL = CMSURL().BASEURL + 'getLayout3';
    let Finalinit = { ...GetHeader() };

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

//page
export async function getPage(SID) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PAGEURL().BASEURL + 'getPage';

    //prepare data
    let finalData = {
      "SID": SID
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function savePage(pageData) {

  try {
    const FINALURL = PAGEURL().BASEURL;

    //prepare data
    let finalData = {
      "data": pageData
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function exportXML(data) {

  try {
    const FINALURL = FILEURL().BASEURL + 'exportXML';

    //prepare data
    let finalData = {
      data: data
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function saveSchedule(saveData) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'saveSchedule';

    //prepare data
    const finalData = {
      data: saveData,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function getVariation(payload) {

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'getVariation';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function saveUserPreference(saveData) {

  try {
    const FINALURL = USERURL().BASEURL + 'saveUserPreference';

    //prepare data
    const finalData = {
      data: saveData
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function saveAdminUserPreferenceToNewUser(userId) {

  try {
    const FINALURL = USERURL().BASEURL + 'saveAdminUserPreferenceToNewUser';

    //prepare data
    const finalData = {
      userId: userId
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function exportCSV(data) {

  try {
    const FINALURL = FILEURL().BASEURL + 'exportCSV';

    //prepare data
    let finalData = {
      data: data
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteEntities(tableName, data) {

  try {
    const FINALURL = APIURL().BASEURL + tableName;

    //prepare data
    let finalData = {
      data: data
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteLogHistory() {

  try {
    const FINALURL = DELETELOGURL().BASEURL;

    let Finalinit = { ...GetHeader("POST") };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteProgramScheduleDraft() {

  try {
    console.log("deleteProgramScheduleDraft");
    const FINALURL = DELETEPROGRAMSCHEDULEDRAFTURL().BASEURL;
    let Finalinit = { ...GetHeader("POST") };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteDataByQuerry(tableName, query) {

  try {
    const FINALURL = APIURL().BASEURL + 'deleteData/' + tableName;

    //prepare data
    let finalData = {
      query: query
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function getContentDetailsFromPartner(args) {

  utility.checkSessionExpire();

  try {
    // let finalData = {
    //   searchtext:args.SearchTextValue
    // };

    let Finalinit = { ...GetHeader(args.RequestType) };
    //Finalinit.mode= 'no-cors'; 
    // const FINALURL = APIURL().BASEURL + 'getImdbDetails?searchtext='+args.SearchTextValue;
    // const FINALURL = args.Url + '?'+args.SearchText+'='+args.SearchTextValue;
    const FINALURL = args.Url + args.QueryString;
    // console.log(FINALURL);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}


//page
export async function readFile(file, headerRowIndex = 0, sheetIndex = 0) {

  if (headerRowIndex < 0 || sheetIndex < 0) {
    return { success: false, message: "Invalid headerRowIndex or sheetIndex", data: { data: undefined } }
  }

  var ext = file.name.split('.').pop().toLowerCase();

  var url = FILETYPEURL[ext];
  //console.log();
  try {
    const FINALURL = FILEURL().BASEURL + url;
    let formData = new FormData()
    formData.append('file', file);
    formData.append('headerRowIndex', headerRowIndex);
    formData.append('sheetIndex', sheetIndex);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, data: { data: undefined } }

  }


}

export async function getExcelSheets(file) {

  try {
    const FINALURL = FILEURL().BASEURL + 'getExcelSheets';
    let formData = new FormData()
    formData.append('file', file);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, data: { data: undefined } }

  }

}


export async function readWhatsOnPlaylist(file) {
  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'readWhatsOnPlaylist';
    let formData = new FormData()
    formData.append('file', file);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    data = { data: undefined }
    return { success: false, message: error.message, data: data }

  }


}

export async function importWhatsOnPlaylist(payload) {

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'importWhatsOnPlaylist';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function readBookingPdf(file) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'readBookingPdf';
    let formData = new FormData()
    formData.append('file', file);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    data = { data: undefined }
    return { success: false, message: error.message, data: data }

  }


}



export async function importPlanning(planningData, canReplace, createMedia = false) {

  try {
    const currentUser = utility.getValue(LOCALSTORAGE_KEY.userData);
    let FINALURL = PLANNINGURL().BASEURL + 'importPlanning';

    const finalData = {
      data: planningData,
      canReplace: canReplace,
      createMedia: createMedia,
      userId: currentUser?._id ?? ''
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function createSegmentsBasedOnFormatsAttached(attachedFormats, MediaEpisodeSID) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'createSegmentsBasedOnFormatsAttached';

    //prepare data
    const finalData = {
      data: { MediaEpisodeSID: MediaEpisodeSID, Formats: attachedFormats }
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function createFastSegments(payload) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = MEDIAURL().BASEURL + 'createFastSegments';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ ...payload, user: { _id: user?._id, name: user?.name } }) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}
export async function updateSeasonEpisodeCount(payload) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'updateSeasonEpisodeCount';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function getDummyMedia(payload) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'getDummyMedia';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function insertProgramGroup(payload) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let FINALURL = PLANNINGURL().BASEURL + 'insertProgramGroup';
    let finalData = {
      ...payload,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

//campaign
export async function getCampaignBookedSpots(campaign_id, filter) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getCampaignBookedSpots';

    const finalData = {
      CampaignID: campaign_id,
      filter: filter
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function deleteScheduledSpots(ids) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'deleteScheduledSpots';

    const finalData = {
      scheduleSpotIds: ids
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

//data migration

export async function ImportMediaManagement(payload, type) {

  //Payload
  // {
  //   "type" : "mediaepsiode"
  //   "data": gridData,
  // }

  try {
    const FINALURL = '';

    if (type.Description == 'Segment') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importSegmentation';
    }
    else if (type.Description == 'Playlist') {
      FINALURL = PLANNINGURL().BASEURL + 'importPlaylist';
    }
    else {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importMediaManagement';
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function ImportMediaManagementDataMigration(payload, type) {

  //Payload
  // {
  //   "type" : "mediaepsiode"
  //   "data": gridData,
  // }

  let finalPayload = {
    ...payload,
    user: {
      _id: utility.getValue(LOCALSTORAGE_KEY.userData)?._id ?? "",
      name: utility.getValue(LOCALSTORAGE_KEY.userData)?.name ?? ""
    }
  };

  try {
    let FINALURL = '';

    if (type.Description == 'Publishing Rights') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importSegmentation'; //importPublishingRights
    }
    else if (type.Description == 'Segment') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importSegmentation';
    }
    else if (type.Description == 'BTS Segmentation') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importBTSSegmentation';
    }
    else if (type.Description == 'Playlist') {
      FINALURL = PLANNINGURL().BASEURL + 'importPlaylist';
    }
    else if (type.Description == 'Series') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importSeries';
    }
    else if (type.Description == 'Season') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importSeasons';
    }
    else if (type.Description == 'Episode') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importEpisodes';
    }
    else if (type.Description == 'Movie' || type.Description == 'Program') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importMovieProgram';
    }
    else // working for interstitial,commercial,filler,music
    {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importInterstialsCommercialFillerMusic';
    }

    console.log(FINALURL)

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalPayload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function importOttAsset(payload) {

  try {
    const FINALURL = OTTURL().BASEURL + 'importOttAssets';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function importPlaylistIngestion(payload) {

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'importPlaylistIngestion';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function importAgencyClient(payload, type) {

  try {
    const FINALURL = '';

    if (type.SID == INGESTION_MODULETYPES.Agency) {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'saveAgency';
    } else {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'saveClient';
    }

    console.log(FINALURL)

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function importOPTADetails(payload) {

  try {
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'importOPTADetails';

    console.log(FINALURL)

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function importMAMAssets(payload) {

  try {
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'importMAMAssets';

    console.log(FINALURL)

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

// PARTNER INGESTION VIA API's
export async function getMappedDataFromAPI(payload) {

  utility.checkSessionExpire();

  try {

    let FINALURL = DATAMIGRATIONURL().BASEURL + 'getMappedDataFromAPI';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    let response = await fetch(FINALURL, Finalinit);

    let responseData = await response.json();
    return responseData;
  } catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function readPlannerGridCSV(file) {

  try {
    const FINALURL = FILEURL().BASEURL + 'readPlannerGridCSV';
    let formData = new FormData()
    formData.append('file', file);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, data: { data: undefined } }

  }


}


export async function readScheduleBssFile(file) {

  try {
    const FINALURL = FILEURL().BASEURL + 'readScheduleBssFile';
    let formData = new FormData()
    formData.append('file', file);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, data: { data: undefined } }

  }


}




export async function SaveLogs(logData) {

  if (!utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.isLogEnabled) ?? false) {
    return;
  }

  const userData = utility.getValue(LOCALSTORAGE_KEY.userData);

  try {
    const payload =
    {
      "data":
      {
        "Event": logData.event,
        "Message": logData.message,
        "User": { _id: userData?._id ?? "", name: userData?.name ?? "" },
        "Module": logData.module,
        "Value": logData.data,
        "Entity_id": logData._id ?? logData.data?._id ?? "",
      }
    }

    const FINALURL = LOGGERURL().BASEURL + 'savelogs';

    let Finalinit = { ...GetHeader("POST", false), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function SaveProgramScheduleHeaderLogs(logData) {

  if (!utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.isLogEnabled) ?? false) {
    return;
  }

  const userData = utility.getValue(LOCALSTORAGE_KEY.userData);

  try {

    const prepareData = {
      _id: logData?.data?._id,
      SID: logData?.data?.SID,
      Channel: { _id: logData?.data?.Channel?._id, SID: logData?.data?.Channel?.SID, FullChannelName: logData?.data?.Channel?.FullChannelName },
      MediaEpisode_id: logData?.data?.MediaEpisode_id,
      SegmentDuration: logData?.data?.mediaEpisode?.Duration ?? 0,
      ScheduleDate: logData?.data?.ScheduleDate,
      SlotDateTime: logData?.data?.SlotDateTime,
      Segment_id: logData?.data?.Segment_id,
      ParentProgramSchedule_id: logData?.dat?.ParentProgramSchedule_id,
      IsValid: logData?.data?.IsValid,
      MediaDealRight_id: logData?.data?.MediaDealRight_id,
      ExhibitionNumber: logData?.data?.ExhibitionNumber,
      RepeatNumber: logData?.data?.RepeatNumber,
      PlanningType: logData?.data?.PlanningType,
      InvalidReason: logData?.data?.InvalidReason,
      customTitle: logData?.data?.customTitle ?? '',
      customDuration: logData?.data?.customDuration ?? 0,
      mediaEpisode: {
        _id: logData?.data?.mediaEpisode?._id,
        SID: logData?.data?.mediaEpisode?.SID,
        Title: logData?.data?.mediaEpisode?.Title,
        Description: logData?.data?.mediaEpisode?.Description,
        AssetId: logData?.data?.mediaEpisode?.AssetId,
        Duration: logData?.data?.mediaEpisode?.Duration,
        EpisodeNumber: logData?.data?.mediaEpisode?.EpisodeNumber,
      }
    }

    const payload = {
      "data": {
        "Event": logData.event,
        "Message": logData.message,
        "User": { _id: userData?._id ?? "", name: userData?.name ?? "" },
        "Module": logData.module,
        "Value": prepareData,
        "Entity_id": logData._id ?? prepareData?._id ?? "",
        "Header_id": logData._id ?? prepareData?._id ?? "",
        "MediaEpisode_id": logData._id ?? prepareData.mediaEpisode?._id ?? "",
      }
    }

    console.log(payload);

    let FINALURL = LOGGERURL().BASEURL + 'saveProgramScheduleHeaderLogs';

    let Finalinit = { ...GetHeader("POST", false), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getCount(entityname, query = "") {

  utility.checkSessionExpire();

  try {

    const FINALURL = APIURL().BASEURL + 'getCount/' + entityname + "?" + query;
    let Finalinit = { ...GetHeader() };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function loadBillingData(billingData) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BILLINGURL().BASEURL + 'loadBillingData';

    const finalData = {
      data: billingData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function loadGeneratedBills(query) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BILLINGURL().BASEURL + 'loadGeneratedBills';

    const finalData = {
      data: query
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}



export async function getInvoiceDetails(billingData) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BILLINGURL().BASEURL + 'getInvoiceDetails';

    const finalData = {
      data: billingData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function saveBills(billingData) {


  try {
    const FINALURL = BILLINGURL().BASEURL + 'saveBills';

    const finalData = {
      data: billingData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}


export async function getInvoiceTelecastDetails(billingData) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BILLINGURL().BASEURL + 'getInvoiceTelecastDetails';

    const finalData = {
      data: billingData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getSecondaryEventStyleSheetsWithPrototypes(styleSheetListRes) {

  utility.checkSessionExpire();

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'getSecondaryEventStyleSheetsWithPrototypes';

    const finalData = {
      _ids: styleSheetListRes.styleSheetList.map((x) => x._id),
      scheduleDate: styleSheetListRes.scheduleDate || null
    }
    console.log(finalData);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function getCampaignOverAllDetails(billingData) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BILLINGURL().BASEURL + 'getCampaignOverAllDetails';
    const finalData = {
      data: billingData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}




//Dashboard
export async function getCMSDashBoardView() {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getCMSDashBoardView'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ data: '' }) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getTop10Agency(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getTop10Agency'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getTop10Client(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getTop10Client'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getRevenueByLocation(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getRevenueByLocation'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getBookingSummaryDashboardData(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getBookingSummaryDashboardData'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function getBookingByDealType(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getBookingByDealType'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getSalesTargetvsAchived(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getSalesTargetvsAchived'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getContentCategories(contetnCategoryId = null) {
  try {
    const FINALURL = MEDIAURL().BASEURL + 'getContentCategories'
    let Finalinit = { ...GetHeader('POST'), body: JSON.stringify({ contetnCategoryId: contetnCategoryId }) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMediaFromContentCategory(contetnCategoryId = null) {
  try {
    const FINALURL = MEDIAURL().BASEURL + 'getMediaFromContentCategory'
    let Finalinit = { ...GetHeader('POST'), body: JSON.stringify({ contetnCategoryId: contetnCategoryId }) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getTotalAndActiveCount(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getTotalAndActiveCount'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function getPendingVsOnAirBooking(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getPendingVsOnAirBooking'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function printBill(billingDataToPrint) {

  try {
    const FINALURL = BILLINGURL().BASEURL + 'printBill';

    const finalData = {
      data: billingDataToPrint
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMonthylRevenue(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getMonthylRevenue'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}



export async function ImportPlaylist(payload, type) {

  //Payload
  // {
  //   "type" : "mediaepsiode"
  //   "data": gridData,
  // }

  try {
    // WINDOW TO WEB
    // PLANNINGURL().BASEURL + 'importPlaylist';

    const FINALURL = SCHEDULINGURL().BASEURL + 'importPlaylist';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}



export async function getAndSaveNextInvoiceNumber(billingData) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BILLINGURL().BASEURL + 'getAndSaveNextInvoiceNumber';

    const finalData = {
      data: billingData
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}



export async function exportBooking(bookingData, months, years, isFromYearlyBooking = false) {

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'exportBooking';

    const finalData = {
      data: bookingData,
      isFromYearlyBooking: isFromYearlyBooking,
      months: months,
      years: years
    }

    console.log(FINALURL);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

// Program Schedule Clash data filter
export async function getProgramScheduleClash(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'getProgramScheduleClash'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function getMakeGoodSpotData() {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + '/getMakeGoodSpotData';
    console.log(FINALURL)
    let Finalinit = { ...GetHeader() };
    console.log(Finalinit)
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData)
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getRecentFiveJobs() {
  try {
    console.log(BOOKINGSUMMARYURL().BASEURL)
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + '/getRecentFiveJobs';
    let Finalinit = { ...GetHeader() };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData)
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getSegmentCollectionData() {
  utility.checkSessionExpire();
  try {
    const FINALURL = MONETIZATION().BASEURL + 'getSegmentCollectionData'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify() }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    console.log(data);
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getSubscribers(args = defaultArgs, columns, searchText, filters) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      filters: filters
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = MONETIZATION().BASEURL + 'getSubscribers';
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function updateSubscriberPackage(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = OTTURL().BASEURL + 'updateSubscriberPackage'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}



export async function changeOldPassword(payload) {
  try {
    const FINALURL = USERURL().BASEURL + 'changeOldPassword'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    console.log(data);
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

//WORK ORDER
export async function getUserWiseWorkOrder() {

  utility.checkSessionExpire();

  try {
    const FINALURL = WORKORDERURL().BASEURL + '/getUserWiseWorkOrder';
    let Finalinit = { ...GetHeader() };

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getRoleWiseWorkOrder() {

  utility.checkSessionExpire();

  try {
    const FINALURL = WORKORDERURL().BASEURL + '/getRoleWiseWorkOrder';
    let Finalinit = { ...GetHeader() };

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function createWorkOrder(payload, workflow) {
  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = WORKORDERURL().BASEURL + 'createWorkOrder'

    //prepare data
    const finalData = {
      data: payload,
      workflow: workflow,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function globalSearch(searchText) {
  try {

    const FINALURL = APIURL().BASEURL + 'globalSearch/' + searchText;
    let Finalinit = { ...GetHeader() };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

//LIVE EVENT
export async function getLiveEventsTournamentData(id) {
  utility.checkSessionExpire();

  try {
    let FINALURL = LIVEEVENTURL().BASEURL + 'getLiveEventsTournamentData';
    if (id) {
      FINALURL += `?_id=${id}`;
    }
    let Finalinit = { ...GetHeader() };

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}
export async function getLiveEventsTournamentMatches(tournamentId, filter) {
  utility.checkSessionExpire();

  try {
    const FINALURL = LIVEEVENTURL().BASEURL + 'getLiveEventsTournamentMatches';

    //prepare data
    const finalData = {
      tournamentId: tournamentId,
      filter: filter
    }

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function scheduleMatch(payload) {

  try {
    const FINALURL = LIVEEVENTURL().BASEURL + '/scheduleMatch';

    //prepare data
    const finalData = {
      payload: payload,
    }

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function exportLiveEventCSV(payload) {

  try {
    const FINALURL = LIVEEVENTURL().BASEURL + '/exportLiveEventCSV';

    //prepare data
    const finalData = {
      payload: payload,
    }

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

// manage content
export async function getMediaEpisodeFromManageContent(args) {
  utility.checkSessionExpire();
  // {
  //     fromDate: "1686043000659",
  //     toDate: "1686043000659",
  //     platformSID: 0,   0 = All
  //     regionSID: 0,     0 = All
  // }
  try {
    // let finalData = {
    //   fromDate: args.fromDate,
    //   toDate: args.toDate,
    //   platformSID: args.platformSID,
    //   regionSID: args.regionSID,
    // };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(args) };
    const FINALURL = MANAGECONTENTURL().BASEURL + 'getMediaEpisodeFromManageContent';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getManageContentExport(args) {

  // {
  //     fromDate: "1686043000659",
  //     toDate: "1686043000659",
  //     platformSID: 0,   0 = All
  //     regionSID: 0,     0 = All
  // }
  try {
    // let finalData = {
    //   fromDate: args.fromDate,
    //   toDate: args.toDate,
    //   platformSID: args.platformSID,
    //   regionSID: args.regionSID,
    // };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(args) };
    const FINALURL = MANAGECONTENTURL().BASEURL + 'getManageContentExport';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    console.log(responseData);
    if (responseData.success) return responseData
    else return responseData;

    // const data = await response.json();
    // return data;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function getBookingScheduleStatus(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getBookingScheduleStatus'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getBookingStatus(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getBookingStatus'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMediaHistory(media, isFromContract = false, segementId, filter) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + 'getMediaHistory';

    const finaldata = { media: media, isFromContract: isFromContract, segementId: segementId, filter };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finaldata) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getInterstitialHistoryReport(payload) {
  utility.checkSessionExpire();
  try {
    const FINALURL = REPORTSURL().BASEURL + 'getInterstitialHistoryReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getClientAgencyBookingReport(payload) {
  try {
    console.log(payload)
    const FINALURL = REPORTSURL().BASEURL + 'getClientAgencyBookingReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMissingMediaReport(payload) {
  try {
    const FINALURL = REPORTSURL().BASEURL + 'getMissingMediaReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getCampaignsExistingBookingDetails(campaignNo) {
  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getCampaignsExistingBookingDetails';

    //prepare data
    const finalData = {
      campaignNo: campaignNo
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getCampaignMaxLineNo(campaignNo) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getCampaignMaxLineNo';

    const finalData = {
      campaignNo: campaignNo
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function linkMediaAndJobs(media, job) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'linkMediaAndJobs';

    //prepare data
    const finalData = {
      media: media,
      job: job
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function createMultipleEpisodeVersions(payload) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'createMultipleEpisodeVersions';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

//ott

export async function getAssets(args = defaultArgs, columns, searchText, filters, assetType) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      filters: filters,
      assetType: assetType
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = OTTURL().BASEURL + 'getAssets';
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function onPublishSeason(id) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    const FINALURL = OTTURL().BASEURL + 'onPublishSeason';

    let finalData = {
      seasonId: id,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getTop5SalesExecutive(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getTop5SalesExecutive'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "should not be less than zero" });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}
export async function printTelecastInPdf(telecastDataInPdf) {
  try {
    console.log(telecastDataInPdf)
    const FINALURL = BILLINGURL().BASEURL + 'printTelecastInPdf';
    console.log(telecastDataInPdf)
    const finalData = {
      data: telecastDataInPdf
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}
export async function printTelecastInExcel(telecastDataInExcel) {
  try {
    console.log(telecastDataInExcel)
    const FINALURL = BILLINGURL().BASEURL + 'printTelecastInExcel';
    console.log(telecastDataInExcel)
    const finalData = {
      data: telecastDataInExcel
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function cancelInvoice(generatedBill_id) {

  try {
    const FINALURL = BILLINGURL().BASEURL + 'cancelInvoice';

    const finalData = {
      data: generatedBill_id
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

// Filter Data collection Campaign
export async function getCampaign(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getCampaign';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

// Filter Data collection Campaign
export async function setAsDefault(entityname, dataID) {

  try {
    const FINALURL = APIURL().BASEURL + 'setAsDefault/0';
    const finalData = {
      entityName: entityname,
      dataID: dataID
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getAmazonMECXML(exportDataItem) {
  try {
    const FINALURL = AMAZONMMCMEFXML().BASEURL + 'getAmazonMECXML';
    //prepare data
    let finalData = {
      data: exportDataItem
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}
export async function getAmazonMMCXML(exportDataItem) {
  try {
    const FINALURL = AMAZONMMCMEFXML().BASEURL + 'getAmazonMMCXML';
    //prepare data
    let finalData = {
      data: exportDataItem
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPrePostlogReportData(payload, isPreLogReport) {
  try {
    console.log(payload)
    var payload = {
      data: payload,
      isPreLogReport: isPreLogReport
    }
    const FINALURL = REPORTSURL().BASEURL + 'getPrePostlogReportData'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function ImportSalesData(payload, type) {

  console.log(type);

  try {
    const FINALURL = '';

    if (type.Description == 'BossWindowSalesExecutives') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'importSalesExecutives';
    }
    else if (type.Description == 'BossWindowAgency') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'saveAgency';
    }

    else if (type.Description == 'BossWindowClient') {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'saveClient';
    }
    else {
      FINALURL = DATAMIGRATIONURL().BASEURL + 'saveCampaign';
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function getCreditLineReport(payload) {
  try {
    console.log(payload)
    const FINALURL = REPORTSURL().BASEURL + 'getCreditLineReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

//Server heath page 
export async function getServerHealth() {

  utility.checkSessionExpire();

  try {
    const FINALURL = SERVERHEALTHURL().BASEURL + '/';
    let Finalinit = { ...GetHeader() };

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPurgeSpotReport(payload) {
  try {
    console.log(payload)
    const FINALURL = REPORTSURL().BASEURL + 'getPurgeSpotReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function printBillInTextFormat(billingDataToPrint) {

  try {
    const FINALURL = BILLINGURL().BASEURL + 'printBillInTextFormat';

    const finalData = {
      data: billingDataToPrint
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function getAirTimeConsumptionReport(payload) {
  try {
    console.log(payload)
    const FINALURL = REPORTSURL().BASEURL + 'getAirTimeConsumptionReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getAndSavePrototypeContentId(SID, saveData) {

  utility.checkSessionExpire();

  try {
    const FINALURL = APIURL().BASEURL + "getAndSavePrototypeContentId/" + SID;

    const finalData = {
      data: saveData,
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getUserByPlanData() {

  utility.checkSessionExpire();

  try {
    const FINALURL = MONETIZATION().BASEURL + 'getUserByPlanData'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify() }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    console.log(data);
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function attachFormats(payload) {

  try {
    const FINALURL = MEDIAURL().BASEURL + 'attachFormats'
    const finalData = {
      data: payload
    }
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    console.log(data);
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportGridExcel(gridData, dataColumns, entityName) {

  try {
    const FINALURL = FILEURL().BASEURL + 'exportGridExcel'
    const finalData = {
      data: gridData,
      columns: dataColumns,
      entityName: entityName
    }
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    console.log(data);
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getContractRunReport(media) {
  console.log(media);
  try {
    const FINALURL = MEDIAURL().BASEURL + 'getContractRunReport';

    const finaldata = { media: media };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finaldata) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getBookingScheduleAndPendingCount(payload) {
  try {
    const FINALURL = BOOKINGSUMMARYURL().BASEURL + 'getBookingScheduleAndPendingCount'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getCampaignPendingApproval() {
  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getCampaignPendingApproval'
    let Finalinit = { ...GetHeader() }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function readBookingTemplateFile(file) {

  //console.log();
  try {
    const FINALURL = FILEURL().BASEURL + 'readBookingTemplateFile';
    let formData = new FormData()
    formData.append('file', file);

    let Finalinit = { method: 'POST', body: formData };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, data: { data: undefined } }

  }


}

export async function getBillingSummaryReport(payload) {
  try {
    console.log(payload)
    const FINALURL = REPORTSURL().BASEURL + 'getBillingSummaryReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportBookingScheduleStatus(bookingSchedule, headerDates) {
  try {
    const FINALURL = REPORTSURL().BASEURL + 'exportBookingScheduleStatus'
    let finalData = {
      data: bookingSchedule.map(x => { return { ...x, bookingdatestring: moment(new Date(x.bookingdate)).format("DD-MMM-YYYY") } }),
      dates: headerDates
    }
    console.log(finalData);
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getShowCreditLineReportData(payload) {
  try {
    const FINALURL = REPORTSURL().BASEURL + 'getShowCreditLineReportData'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function isCreditAvaliable(selectedCampaign, currentAmount) {
  try {
    const FINALURL = BOOKINGURL().BASEURL + 'isCreditAvaliable'
    let finalData = {
      data: selectedCampaign,
      currentAmount: currentAmount
    }
    console.log(finalData);
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getScheduledAnnouncement(filterQuery) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'getScheduledAnnouncement'
    let finalData = {
      data: filterQuery
    }
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getTopNews() {
  utility.checkSessionExpire();
  try {
    const FINALURL = OTTURL().BASEURL + 'getTopNews'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify() }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMediaMasterReport(filters, download = false) {
  try {
    let finalData = {
      filters: filters,
      download: download
    }

    const FINALURL = REPORTSURL().BASEURL + 'getMediaMasterReport';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.success) {
      return data;
    }
    utility.checkTokenExpire(data);
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function exportBookingStatus(payload) {
  try {
    let FINALURL = REPORTSURL().BASEURL + 'exportBookingStatus';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getRailsWithCampaign(args = defaultArgs, columns, searchText, isActiveRails = RAIL_STATUS.All) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      isActive: isActiveRails
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = OTTURL().BASEURL + 'getRailsWithCampaign';
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPages(args = defaultArgs, columns, searchText, isActiveRails = RAIL_STATUS.All) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      isActive: isActiveRails
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = OTTURL().BASEURL + 'getPages';
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getBottomMenu() {

  utility.checkSessionExpire();

  try {


    let Finalinit = { ...GetHeader() };
    const FINALURL = OTTURL().BASEURL + 'getBottomMenu';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getOttSettings() {

  utility.checkSessionExpire();

  try {


    let Finalinit = { ...GetHeader('Post') };
    const FINALURL = OTTURL().BASEURL + 'getOttSetting';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPagesV2(args = defaultArgs, columns, searchText, isActiveRails = RAIL_STATUS.All) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      isActive: isActiveRails
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = OTTURL().BASEURL + 'getPagesV2';
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function downloadFile(fileName) {
  try {
    const FINALURL = FILEURL().BASEURL + 'downloadFile/' + fileName;
    let Finalinit = {
      ...GetHeader(),
    };
    try {
      const response = await fetch(FINALURL, Finalinit);
      //download the file
      const responseData = await response.blob();
      const url = window.URL.createObjectURL(new Blob([responseData]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    }
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function downloadZip(payload) {
  try {
    const FINALURL = FILEURL().BASEURL + 'downloadZip';
    const Finalinit = { ...GetHeader("POST"), body: JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    if (!response.ok) {
      throw new Error(`Failed to download: ${response.statusText}`);
    }

    const responseData = await response.blob();
    const url = window.URL.createObjectURL(responseData);

    // Corrected file name
    const fileName = `${payload.folderName ? payload.folderName : 'file'}.zip`;

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download error:", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function saveFAQ(data) {

  try {
    const FINALURL = FILEURL().BASEURL + 'saveFAQ';

    const finalData = {
      data: data
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function languageTranslator(text, target) {
  try {
    let FINALURL = TRANSLATORURL().BASEURL + 'languageTranslator';

    const finalData = {
      text: text,
      target: target
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, data: { data: undefined } }

  }


}

//get entities function with search for server side search
export async function getEntitiesSearchWithMedia(entityname, args = defaultArgs, columns, searchText, filters, mediaCategorySID, channelFilter) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      filters: filters,
      user: { _id: user?._id ?? "", name: user?.name ?? "" },
      mediaCategorySID: mediaCategorySID,
      channelFilter: channelFilter || []
    };
    console.log(finalData);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = APIURL().BASEURL + 'getEntitiesSearchWithMedia/' + entityname;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getEntitiesSearchWithMediaGlobal(args = defaultArgs, columns, searchText, filters, mediaCategorySID, channelFilter) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      filters: filters,
      user: { _id: user?._id ?? "", name: user?.name ?? "" },
      mediaCategorySID: mediaCategorySID,
      channelFilter: channelFilter || []
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const FINALURL = APIURL().BASEURL + 'getEntitiesSearchWithMediaGlobal';
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getEntitiesWithSearchForShortMedia(entityname, args = defaultArgs, columns, searchText, filters) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      filters: filters,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = APIURL().BASEURL + 'getEntitiesWithSearchForShortMedia/' + entityname;
    console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function uploadPDF(file) {

  try {
    let FINALURL = FILEURL().BASEURL + 'uploadPDFOnCloudinary';

    const formData = new FormData();
    formData.append('file', file);

    const finalInit = {
      method: 'POST',
      body: formData,
    };

    const response = await fetch(FINALURL, finalInit);
    const responseData = await response.json();

    if (responseData.success) return responseData.data;
    else return responseData;
  } catch (error) {
    ;
    console.log("error", error);
    return { success: false, message: error.message }
  }
}
export async function printBillInExcel(billingDataToPrint) {

  try {
    const FINALURL = BILLINGURL().BASEURL + 'printBillInExcel';

    const finalData = {
      data: billingDataToPrint
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    // console.log(responseData);
    return responseData;


  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function GetCoolitaEPG(payload) {


  try {
    console.log("Coolita")
    let finalData = {
      data: payload
    }
    const FINALURL = PLANNINGURL().BASEURL + 'GetCoolitaEPG'

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    console.log(Finalinit)
    const response = await fetch(FINALURL, Finalinit);
    console.log(response)
    const data = await response.json();
    console.log(data)
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function GetXiaomiEPG(payload) {

  try {
    let finalData = {
      data: payload
    }
    const FINALURL = PLANNINGURL().BASEURL + 'GetXiaomiEPG'

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    console.log(Finalinit)
    const response = await fetch(FINALURL, Finalinit);
    console.log(response)
    const data = await response.json();
    console.log(data)
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}
export async function getContentCounts() {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let FINALDATA = {
      userID: user?._id
    }
    let FINALURL = DASHBOARDURL().BASEURL + 'getContentCounts';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(FINALDATA) };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}
export async function getCMSCounts() {

  try {
    let FINALURL = DASHBOARDURL().BASEURL + 'getCMSCounts';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify() };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}
export async function getMonetizationCounts() {

  try {
    let FINALURL = DASHBOARDURL().BASEURL + 'getMonetizationCounts';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify() };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMonetizationDashBoardData(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MONETIZATION().BASEURL + 'getMonetizationDashBoardData'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getSubscriptionGraphDetails(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MONETIZATION().BASEURL + 'getSubscriptionGraphDetails'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function updateEpisodeReferenceCode(data) {

  try {

    let FINALURL = MEDIAURL().BASEURL + 'updateEpisodeReferenceCode';
    let finalData = {
      data: data
    }
    console.log(finalData);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function canArchiveMediaEpisode(mediaEpisodeId) {

  try {

    let FINALURL = MEDIAURL().BASEURL + 'canArchiveMediaEpisode';
    let finalData = {
      mediaEpisodeId: mediaEpisodeId
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}
export async function getMetaDataFromMediaEpisode(mediaEpisodeSIDs) {

  try {

    let FINALURL = MEDIAURL().BASEURL + 'getMetaDataFromMediaEpisode';
    let finalData = {
      mediaEpisodeSIDs: mediaEpisodeSIDs
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}
export async function validateMediaInSchedule(payload) {
  //payload
  // {
  //     "startDate": 1712296800000, 
  //     "endDate": 1712383199999,
  //     "channelSID": 2,
  // }
  try {

    let FINALURL = SCHEDULINGURL().BASEURL + 'validateMediaInSchedule';
    let finalData = {
      data: payload
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function loadSecondaryEventDefaultPrototypes(channelSID) {

  try {

    let FINALURL = SCHEDULINGURL().BASEURL + 'loadSecondaryEventDefaultPrototypes';
    let finalData = {
      channelSID: channelSID
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function programScheduleDraft(payload) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {

    let FINALURL = SCHEDULINGURL().BASEURL + 'programScheduleDraft';
    let finalData = {
      data: {
        ...payload,
        User: { _id: user?._id, name: user?.name, SID: user?.SID }
      }
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function publishProgramScheduleDraft(payload) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  let finalData = {
    ...payload,
    User: { _id: user?._id, name: user?.name, SID: user?.SID }
  }

  try {

    let FINALURL = SCHEDULINGURL().BASEURL + 'publishProgramScheduleDraft';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getRegionData(SID) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify() };
    let FINALURL = APIURL().BASEURL + 'getRegionData/' + SID;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

    return data;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getIMDBData(data) {

  utility.checkSessionExpire();

  try {
    let payload = {
      searchName: data.SearchName,
      type: data.Type,
      page: data.Page
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = IMDBURL().BASEURL + "getIMDBData";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}
export async function getSpotifyMusicData(payload) {
  //   {
  //     "searchPhrase":"sorry",
  //     "page":2,
  //     "limit":10
  // }

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = THIRDPARTYAPIURL().BASEURL + "searchMusic";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function getSportsEventTournaments(data) {

  utility.checkSessionExpire();

  try {
    let payload = {
      searchKey: data.searchKey,
      TournamentType: data.TournamentType,
      page: data.page
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = LIVEEVENTURL().BASEURL + "getSportsEventTournaments";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getSportsEventTournamentMatches(tournamentId) {

  utility.checkSessionExpire();

  try {
    let payload = {
      tournamentId: tournamentId,
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = LIVEEVENTURL().BASEURL + "getSportsEventTournamentMatches";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function saveSportsEventTournamentAndMatches(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = LIVEEVENTURL().BASEURL + "saveSportsEventTournamentAndMatches";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getMusicById(id) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ id: id }) };
    const FINALURL = THIRDPARTYAPIURL().BASEURL + "getMusicById";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}
export async function getIMDBDetails(imdbID) {

  utility.checkSessionExpire();

  try {
    let payload = {
      imdbID: imdbID
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = IMDBURL().BASEURL + "getIMDBDetails";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function getTMDBData(data) {
  utility.checkSessionExpire();
  try {
    let payload = {
      searchName: data.SearchName,
      page: data.Page
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = TMDBURL().BASEURL + "getTMDBData";
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getTMDBDetails(tmdbID) {
  utility.checkSessionExpire();
  try {
    let payload = {
      tmdbID: tmdbID
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = TMDBURL().BASEURL + "getTMDBDetails";
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getTMDBSeason(tmdbID, seasonNumber) {
  utility.checkSessionExpire();
  try {
    let payload = {
      tmdbID: tmdbID,
      seasonNumber: seasonNumber
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = TMDBURL().BASEURL + "getTMDBSeason";
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function saveIMDbMetaData(mediaSID, imdbData, saveMetaData) {

  utility.checkSessionExpire();

  try {
    let payload = {
      mediaSID: mediaSID,
      imdbData: imdbData,
      saveMetaData: saveMetaData
    }

    console.log(payload);

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = IMDBURL().BASEURL + "saveIMDbMetaData";
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    utility.checkTokenExpire(responseData);
    utility.checkIsLicenseExpire(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function getProgramTimeConsumptionReport(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getProgramTimeConsumptionReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMusicReport(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getMusicReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportPrgramTimeConsumtionReport(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = FILEURL().BASEURL + 'exportPrgramTimeConsumtionReport';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getSegmentationDataExport(payload) {
  try {
    console.log(payload)
    const FINALURL = MEDIAURL().BASEURL + 'getSegmentationDataExport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function loadPlanningSeriesEpisodes(searchText, filterDataItem, pagination, channels = []) {

  utility.checkSessionExpire();

  let finalData = {
    data: searchText,
    filter: filterDataItem,
    pagination: pagination,
    channels: channels.length > 0 ? channels.map((x) => x.SID) : []
  }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'loadPlanningSeriesEpisodes'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function canChangeTxStatusToLiveOrDalayed(slotdatetime, mediaepisode_id) {

  utility.checkSessionExpire();

  let finalData = {
    data: {
      slotdatetime: slotdatetime,
      mediaepisode_id: mediaepisode_id
    }
  }

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'canChangeTxStatusToLiveOrDalayed'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const responsedata = await response.json();

    return responsedata;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function updateUserPreferenceColumnWidth(payload) {
  const user = utility.getValue(LOCALSTORAGE_KEY.userData);
  utility.checkSessionExpire();

  try {
    console.log(payload);
    let finalData = {
      ...payload,
      userId: user?._id
    }
    let FINALURL = APIURL().BASEURL + 'updateUserPreferenceColumnWidth' + "/0";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    console.log(responseData?.message);
    return responseData;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function uploadVideoAndImage(imageData) {

  try {
    let FINALURL = FILEURL().BASEURL + 'uploadVideoAndImageOnCloudinary';

    let formData = new FormData()
    formData.append('file', imageData)

    let Finalinit = { method: 'POST', body: formData };
    let response = await fetch(FINALURL, Finalinit);
    // if (response.status === 413) {
    //   return { success: false, message: "The file you're trying to upload is too large. Please choose a smaller file." }
    // }
    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message }
  }

}

export async function login(userName, password) {

  try {
    const FINALURL = LOGINURL.BASEURL;

    //prepare data
    let finalData = {
      "data": {
        "userName": userName,
        "password": password
      }
    };

    var init = GetHeader("POST");
    let Finalinit = { ...init, "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function getAppVersion() {

  try {
    const FINALURL = CONFIGURL.BASEURL + '/getAppVersion';
    let Finalinit = { ...GetHeader() };

    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getPreviousDayEndTime(payload) {

  utility.checkSessionExpire();
  //payload data:
  // ScheduleDate in ms
  // channelSID

  try {
    const FINALURL = SCHEDULINGURL().BASEURL + 'getPreviousDayEndTime'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function checkDuplicateInterSectTimeBand(value) {

  utility.checkSessionExpire();

  try {
    let FINALURL = APIURL().BASEURL + 'checkDuplicateInterSectTimeBand/0';
    let FinalData = {
      data: value
    }
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(FinalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export const getCompanyData = async (tableName, args = defaultArgs, columns, searchText, languageFilter) => {

  utility.checkSessionExpire();

  try {

    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || { SID: -1 },
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      dataColumns: columns || [],
      archive: args.archive || defaultArgs.archive,
      searchText: searchText || '',
      languageFilter: languageFilter || []
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = get_APIURL(ENTITYNAME.Company) + 'getCompanyData/' + tableName;
    let response = await fetch(FINALURL, Finalinit);
    let data = await response.json();

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getSecondaryEventWithSearch(entityname, args = defaultArgs, columns, searchText) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData);

  try {
    let finalData = {
      userData: { channels: user?.Channels ?? [], RoleType: user?.RoleType },
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = SECONDARYEVENTURL().BASEURL + 'getSecondaryEventWithSearch/' + entityname;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

    return data;

  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function canLockUnlockItem(id, lock) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData);

  try {
    let finalData = {
      id: id,
      lock: lock
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = PLANNINGURL().BASEURL + 'canLockUnlockItem';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

    return data;

  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function deleteCompanyData(_id) {

  try {

    let Finalinit = { ...GetHeader("DELETE"), "body": JSON.stringify() };

    const response = await fetch(`${APIURL().BASEURL}/${_id}`, Finalinit);
    const resData = await response.json();

    return resData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function lockItem(header, children, isSave = true, nextHeaderSlotDateTime) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData);

  try {
    let finalData = {
      header: header,
      children: children,
      isSave: isSave,
      nextHeaderSlotDateTime: nextHeaderSlotDateTime
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = PLANNINGURL().BASEURL + 'lockItem';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

    return data;

  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function unlockItem(header, children) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData);

  try {
    let finalData = {
      header: header,
      children: children,
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = PLANNINGURL().BASEURL + 'unlockItem';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

    return data;

  }
  catch (error) {
    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    return { success: false, message: error.message, error: error };
  }
}

export async function uploadFile(file) {

  utility.checkSessionExpire();

  try {

    let FINALURL = FILEURL().BASEURL + 'uploadFile';

    let formData = new FormData()
    formData.append('file', file)

    let Finalinit = { method: 'POST', body: formData };
    let response = await fetch(FINALURL, Finalinit);

    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteFile(fileName) {

  utility.checkSessionExpire();

  try {

    let FINALURL = FILEURL().BASEURL + 'deleteFile';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ fileName: fileName }) };
    let response = await fetch(FINALURL, Finalinit);

    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    return { success: false, message: error.message, error: error };
  }

}

//
export async function deleteFileV2(filePath) {

  utility.checkSessionExpire();

  try {

    let FINALURL = FILEBUCKETURL().BASEURL + 'deleteFile';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ id: filePath }) };
    let response = await fetch(FINALURL, Finalinit);

    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function readFileNameWithContent(fileName) {

  utility.checkSessionExpire();

  try {

    let FINALURL = FILEURL().BASEURL + 'readFileNameWithContent';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ fileName: fileName }) };
    let response = await fetch(FINALURL, Finalinit);

    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getIngestionReport(filters) {
  try {
    let finalData = {
      filters: filters
    }

    const FINALURL = REPORTSURL().BASEURL + 'getIngestionReport';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.success) {
      return data;
    }
    utility.checkTokenExpire(data);
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function checkUserExists(loginUserId, email) {
  try {
    let finalData = {
      user_id: loginUserId,
      email: email
    }
    let FINALURL = USERURL().BASEURL + 'checkUserExists';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) };
    let response = await fetch(FINALURL, Finalinit);
    let data = await response.json();
    utility.checkTokenExpire(data);
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}


export async function showSchedule(payload) {

  utility.checkSessionExpire();

  try {

    let FINALURL = MEDIAURL().BASEURL + 'showSchedule';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    let response = await fetch(FINALURL, Finalinit);

    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
  }

}

export async function getIngestionLogsData(payload) {
  try {
    console.log(payload)
    const FINALURL = INGESTIONLOGURL().BASEURL + 'getIngestionLogsData'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportMediaContent(payload) {
  try {
    console.log(payload)
    const FINALURL = REPORTSURL().BASEURL + 'exportMediaContent'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function getXMLExport(mediaId) {

  try {

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    let payload = {
      media_id: mediaId,
      type: company.Name && company.Name.toLowerCase() == "action24" ? "ross" : "boss"
    }

    const FINALURL = MEDIAURL().BASEURL + 'getXMLExport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getXMLExportV2(media) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    let FINALURL = MEDIAURL().BASEURL + 'getXMLExportV2'

    let payload = {
      media: media,
      type: company.Name && company.Name.toLowerCase() == "action24" ? "ross" : "boss",
      user: {
        _id: user?._id,
        name: user?.name
      }
    }

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getEntitiesWithSearchAndLanguage(entityname, args = defaultArgs, columns, searchText, languageFilter) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      languageFilter: languageFilter || []
    };

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const FINALURL = get_APIURL(entityname) + 'getEntitiesWithSearchAndLanguage/' + entityname;

    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);
    utility.checkIsLicenseExpire(data);

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getAcquitionReport(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getAcquitionReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function loadContractMediaLibrary(searchText, pagination, channels = [], searchColumns = []) {

  utility.checkSessionExpire();

  let finalData = {
    searchText: searchText,
    pagination: pagination,
    channels: channels.length > 0 ? channels.map((x) => x.SID) : [],
    searchColumns: searchColumns
  }

  try {
    let FINALURL = PLANNINGURL().BASEURL + 'loadContractMediaLibrary'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    if (data.success) {
      return data;
    }
    utility.checkTokenExpire(data);
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error }
  }

}

export async function getAmortizationRule(payload) {

  try {
    let FINALURL = CONTRACTURL().BASEURL + 'getAmortizationRule';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error }
  }


}

export async function getAmortizationValueReport(payload) {

  try {
    let FINALURL = CONTRACTURL().BASEURL + 'getAmortizationValueReport';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error }
  }
}

export async function getBudgetData(_id) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getBudgetData';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ _id }) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error }
  }
}

export async function publishOrUnPublishCampaign(payload) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'publishOrUnPublishCampaign';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error }
  }
}


export async function getAmount(finalData) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getAmount';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error }
  }
}

//BOSS ASSISTANT
export async function bossAssistant(payload) {

  try {
    let FINALURL = BOSS_ASSISTANT_URL().BASEURL + 'bossAssistant';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error }
  }

}

export async function getGeoLocations(channel, query, limit = 50, locationTypes = ["country"]) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getGeoLocations';
    let Finalinit = {
      ...GetHeader('POST'), "body": JSON.stringify({
        adsConfig: channel,
        query: query,
        limit: limit,
        locationTypes: locationTypes
      })
    }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getInterests(channel, query, limit = 50) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getInterests';
    let Finalinit = {
      ...GetHeader('POST'), "body": JSON.stringify({
        adsConfig: channel,
        query: query,
        limit: limit
      })
    }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getMetaPages(finalData) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getPages';
    let Finalinit = { ...GetHeader('POST'), body: JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getInsightViaId(finalData) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getInsightViaId';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getDashboard(FromDate, ToDate) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getDashboard';
    let Finalinit = {
      ...GetHeader('POST'), "body": JSON.stringify({ FromDate, ToDate })
    }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getAvailableBudget(finalData) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getAvailableBudget';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function publishChannel(_id) {
  try {
    let FINALURL = DAI_URL().BASEURL + 'publishChannel';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ _id }) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function startStopChannel(value) {
  try {
    let FINALURL = DAI_URL().BASEURL + 'startStopChannel';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(value) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function sctePublishedOrUnPublished(payload) {

  try {
    let FINALURL = DAI_URL().BASEURL + 'sctePublishedOrUnPublished';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function deleteScte(value) {

  try {
    let FINALURL = DAI_URL().BASEURL + 'deleteScte';
    let Finalinit = { ...GetHeader('DELETE'), "body": JSON.stringify(value) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function daiChannelDelete(_id) {
  try {
    let FINALURL = DAI_URL().BASEURL + 'daiChannelDelete';
    let Finalinit = { ...GetHeader('DELETE'), "body": JSON.stringify({ _id }) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getRotanaEPGXML(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getRotanaEPGXML';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getPlanningForMediaRepetition(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getPlanningForMediaRepetition';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function exportMissingSegmentMamReport(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'exportMissingSegmentMamReport';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getPaymentPlan(item) {

  try {
    let FINALURL = OTTURL().BASEURL + 'getPaymentPlan';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(item) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function savePaymentProvider(finalData) {

  try {
    let FINALURL = OTTURL().BASEURL + 'savePaymentProvider';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getAssetByID(id) {
  try {
    // old
    // let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ _id: id }) };
    // let FINALURL = CMSURL().BASEURL + '/v2/ott/getAssetById';
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ _id: id, isoCode: isoCode }) };
    let FINALURL = CMSURL().BASEURL + '/v2/ott/getAssetByISOCode';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getUpcomingRailAssets() {

  try {
    // old
    // let FINALURL = CMSURL().BASEURL + '/v2/ott/getBottomMenu';
    // let Finalinit = { ...GetHeader() };
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let FINALURL = CMSURL().BASEURL + '/v2/ott/upcomingAssetsByIsoCode';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ isoCode: isoCode, limit: 100 }) };
    console.log(FINALURL)
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getIP() {
  utility.checkSessionExpire();

  try {
    let FINALURL = "https://api.ipify.org?format=json";

    const response = await fetch(FINALURL, { method: "GET" });
    const data = await response.json();

    return { success: true, data: data.ip, message: "IP Fetched Successfully" }
  } catch (error) {
    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    return { success: false, data: null, message: error.message, error: error };
  }
}

export async function sendToTopic(payload) {

  try {
    let FINALURL = NOTIFICATION_URL().BASEURL + 'sendToTopic';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getAction24EPG(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getAction24EPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getCommercialConsumptionReport(payload) {
  try {
    console.log(payload)
    const FINALURL = REPORTSURL().BASEURL + 'getCommercialConsumptionReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getScheduleExportHisory(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = REPORTSURL().BASEURL + 'getScheduleExportHisory';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function syncSeasonMetadataWithEpisodes(payload, datakey) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + 'syncSeasonMetadataWithEpisodes';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ payload }) };
    const response = await fetch(FINALURL, Finalinit);
    console.log(payload)

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

//NEW SYNC SEASON META DATA WITH EPISODE
export async function syncSeasonMetadataWithEpisodesV2(payload, datakey) {

  utility.checkSessionExpire();

  //payload
  // let payload = {
  //   _id : "", //season id
  //   fields : [],
  // }

  try {
    const FINALURL = MEDIAURL().BASEURL + 'syncSeasonMetadataWithEpisodesV2';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ payload }) };
    const response = await fetch(FINALURL, Finalinit);
    console.log(payload)

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function syncSeasonConfigInEpisodes(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + 'syncSeasonConfigInEpisodes';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getMultiChoiceEPG(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getMultiChoiceEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMusicAiringReport(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getMusicAiringReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getBreakPatternReport(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getBreakPatternReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getFilesFromBucket(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = BUCKET_CONFIGURATION_URL().BASEURL + 'getFilesFromBucket';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMediaByContentCategory({ contentCategoryId }) {

  try {
    const FINALURL = MEDIAURL().BASEURL + "getMediaByContentCategory";
    const finalData = {
      contentCategoryId
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function updateMediaByContentCategory({ mediaIds, entityName, contentCategory }) {

  try {
    const FINALURL = MEDIAURL().BASEURL + "updateMediaByContentCategory";
    const finalData = {
      mediaIds,
      entityName,
      contentCategory
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function onDeleteContentCategory({ id }) {

  try {
    const FINALURL = MEDIAURL().BASEURL + "onDeleteContentCategory";
    const finalData = {
      id
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function updateContentCategoryLinks({ data }) {

  try {
    const FINALURL = MEDIAURL().BASEURL + "updateContentCategoryLinks";
    const finalData = {
      data
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getUnifiTvEPG(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getUnifiTvEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getVODReport(data) {

  try {
    console.log(data);
    let FINALURL = REPORTSURL().BASEURL + 'getVODReport';
    let finalData = {
      data: data
    }
    console.log(finalData);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function bulkUpdateMediaByContentCategory(payload) {

  try {

    const finalData = {
      ...payload
    }
    console.log(finalData);

    const FINALURL = MEDIAURL().BASEURL + "bulkUpdateMediaByContentCategory";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }
    return responseData;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }

}

export async function exportVODXML(data, type) {

  try {
    let FINALURL = REPORTSURL().BASEURL + 'exportVODXML';
    let finalData = {
      data: data,
      type: type
    }
    console.log(finalData);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMediaCountByContentCategory({ contentCategoryId }) {

  try {
    const FINALURL = MEDIAURL().BASEURL + "getMediaCountByContentCategory";
    const finalData = {
      contentCategoryId
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getEncompassAdityaEPG(payload) {

  utility.checkSessionExpire();
  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getEncompassAdityaEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getTransmissions(payload) {

  try {
    const FINALURL = MEDIAURL().BASEURL + "getTransmissions";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function createTransmission(payload) {

  try {

    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const finalData = {
      ...payload,
      user: { _id: user?._id, name: user?.name }
    }

    const FINALURL = MEDIAURL().BASEURL + "createTransmission";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function createTransmissionFromVersion(payload) {

  try {

    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const finalData = {
      ...payload,
      user: { _id: user?._id, name: user?.name }
    }

    console.log(finalData);

    const FINALURL = MEDIAURL().BASEURL + "createTransmissionFromVersion";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function updateTransmission({ query, data }) {

  try {

    const user = utility.getValue(LOCALSTORAGE_KEY.userData);

    const finalData = {
      query,
      data,
      user: { _id: user?._id, name: user?.name }
    }

    const FINALURL = MEDIAURL().BASEURL + "updateTransmission";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function exportStarHub_OTTEPG(payload) {

  utility.checkSessionExpire();
  try {
    const FINALURL = STARHUB_EXPORT_URL().BASEURL + 'exportStarHub_OTTEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportStarHub_Blackout_EPG(payload) {

  utility.checkSessionExpire();
  try {
    const FINALURL = STARHUB_EXPORT_URL().BASEURL + 'exportStarHub_BLACKOUT_EPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}



export async function exportStarHub_FUZE_EPG(payload) {

  utility.checkSessionExpire();
  try {
    const FINALURL = STARHUB_EXPORT_URL().BASEURL + 'exportStarHub_FUZE_EPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function exportStarHub_ATEME_EPG(payload) {

  utility.checkSessionExpire();
  try {
    const FINALURL = STARHUB_EXPORT_URL().BASEURL + 'exportStarHub_ATEME_EPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportStarHub_IPTVEPG(payload) {

  utility.checkSessionExpire();
  try {
    const FINALURL = STARHUB_EXPORT_URL().BASEURL + 'exportStarHub_IPTVEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function createMamIngestWorkOrders(payload) {

  console.log(payload);

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    var finalPayload = {
      payload,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    const FINALURL = STARHUB_EXPORT_URL().BASEURL + 'createMamIngestWorkOrders';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalPayload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function createTranscodeWorkOrder({ mamIds = [], transcodePrototype = null }) {

  utility.checkSessionExpire();
  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    const FINALURL = STARHUB_EXPORT_URL().BASEURL + 'createTranscodeWorkOrder';
    const finalData = {
      mamIds,
      transcodePrototype: transcodePrototype,
      user: { _id: user?._id, name: user?.name }
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function createMAMandWoFromEpisodes({ mediaIds, entityName, transmissionType, ingestPrototype, versionType }) {

  try {

    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const finalData = {
      mediaIds,
      entityName,
      versionType,
      transmissionType,
      ingestPrototype,
      user: { _id: user?._id, name: user?.name }
    }

    const FINALURL = MEDIAURL().BASEURL + "createMAMandWoFromEpisodes";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function createMamAndWorkOrderFromVersion({ segmentId, MediaEpisodeSID, }) {

  try {

    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const finalData = {
      segmentId,
      MediaEpisodeSID,
      user: { _id: user?._id, name: user?.name }
    }

    const FINALURL = MEDIAURL().BASEURL + "createMamAndWorkOrderFromVersion";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function deleteSegment({ segmentId }) {

  try {

    const finalData = {
      segmentId,
    }

    const FINALURL = MEDIAURL().BASEURL + "deleteSegment";
    let Finalinit = { ...GetHeader("DELETE"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function createOrUpdateMediaOffers(payload) {

  utility.checkSessionExpire();

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = MEDIAURL().BASEURL + "createOrUpdateMediaOffers";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ ...payload, user: { _id: user?._id, name: user?.name } }) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function importSegmentTimeCodeTxt(file) {
  try {
    const FINALURL = STARHUB_IMPORT_URL().BASEURL + 'importSegmentTimeCodeTxt';

    let formData = new FormData();
    formData.append('file', file);

    const response = await fetch(FINALURL, { method: 'POST', body: formData });
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return null;
  }
}

export async function unPublishOfferAndRemoveTransmission({ assetOfferLinkId, tableName, multiPayload }) {
  utility.checkSessionExpire();
  try {
    const finalData = {
      assetOfferLinkId,
      tableName,
      multiPayload
    }
    const FINALURL = MEDIAURL().BASEURL + "unPublishOfferAndRemoveTransmission";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function exportTranscodingDublist(query) {
  utility.checkSessionExpire();
  try {
    const FINALURL = FILEURL().BASEURL + "exportTranscodingDublist";
    const finalData = query
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function publishVodCatalogue(payload, publishReportSID, isManual = false) {
  utility.checkSessionExpire();
  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    let FINALURL = STARHUB_EXPORT_URL().BASEURL + 'publishVodCatalogue';
    let finalData = {
      data: payload,
      publishReportSID: publishReportSID,
      isManual: isManual,
      user: user?._id ? { _id: user._id, name: user.name } : {}
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getDataForTrailerBookingIngest(filePath, sheetName) {

  try {
    const finalData = {
      filePath,
      sheetName
    }
    const FINALURL = STARTHUB_TRAILER_WORKFLOW().BASEURL + "getDataForIngest";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function ingestForTrailerBooking(filePath, sheetName) {

  try {
    const finalData = {
      filePath,
      sheetName
    }
    const FINALURL = STARTHUB_TRAILER_WORKFLOW().BASEURL + "ingest";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getAmagiEPG(payload) {

  utility.checkSessionExpire();
  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getAmagiEPG';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getImportExportDashboardData() {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let FINALDATA = {
      userID: user?._id
    }
    let FINALURL = LOGGERURL().BASEURL + 'getImportExportDashboardData';

    let Finalinit = { ...GetHeader("POST", false), "body": JSON.stringify(FINALDATA) };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function deleteManyEntity(entityname, query) {

  try {

    let finalData = {
      query
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(`${APIURL().BASEURL}deleteManyEntity/${entityname}`, Finalinit);
    const resData = await response.json();

    return resData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function exportBreakPattern(payload) {

  utility.checkSessionExpire();

  console.log(payload);

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'exportBreakPattern'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getPublishSetting(payload) {

  utility.checkSessionExpire();

  console.log(payload);

  try {
    const FINALURL = APIURL().BASEURL + 'getPublishSetting'

    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.success) {
      return data;
    }

    utility.checkTokenExpire(data);

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function exportDublistReport(payload) {
  utility.checkSessionExpire();
  try {
    const FINALURL = REPORTSURL().BASEURL + 'exportDublistReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function exportPurgeListReport(payload) {
  utility.checkSessionExpire();
  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    const FINALURL = REPORTSURL().BASEURL + 'exportPurgeListReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ ...payload, user: { _id: user?._id, name: user?.name } }) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function exportTransmissionListReport(payload) {
  utility.checkSessionExpire();
  try {
    const FINALURL = REPORTSURL().BASEURL + 'exportTransmissionListReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getTransmissonsTiles() {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let FINALDATA = {
      userID: user?._id
    }
    let FINALURL = DASHBOARDURL().BASEURL + 'getTransmissonsTiles';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(FINALDATA) };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getNodeReport(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getNodeReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getWorkflowDashboardData() {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let FINALDATA = {
      userID: user?._id
    }
    let FINALURL = DASHBOARDURL().BASEURL + 'getWorkflowDashboardData';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(FINALDATA) };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function ingestAllWithMedia(payload) {

  utility.checkSessionExpire();

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const finalData = {
      ...payload,
      user: { _id: user?._id, name: user?.name }
    }
    const FINALURL = MEDIAURL().BASEURL + "ingestAllWithMedia";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getAssetsOfferLink(payload) {
  console.log(payload);

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + "getAssetsOfferLink";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}


export async function getNodesWithTransmissionCount() {

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + "getNodesWithTransmissionCount";
    let Finalinit = { ...GetHeader("POST") };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getEPGReports(payload, reportType) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getEPGReports';
    let Finalinit = { ...GetHeader("POST"), body: JSON.stringify({ payload, reportType }) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error };
  }
}

export async function importMAMAssetsViaExcel(file) {

  try {
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'importMAMAssetsViaExcel';

    const formData = new FormData();
    formData.append("file", file);

    let Finalinit = { ...GetHeader("POST", true), "body": formData };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message };
  }
}

export async function getBrandProductReport(payload) {
  utility.checkSessionExpire();
  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getBrandProductReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getCampaignReport(payload) {
  utility.checkSessionExpire();
  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getCampaignReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function sendEmail(payload) {
  utility.checkSessionExpire();
  try {
    const FINALURL = MAIL_URL().BASEURL + 'sendEmail';

    let Finalinit = {
      ...GetHeader("POST"),
      body: JSON.stringify(payload)
    };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error };
  }
}

export async function saveAgency(payload) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'saveAgency';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ ...payload, user: { _id: user?._id, name: user?.name } }) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function saveClient(payload) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'saveClient';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ ...payload, user: { _id: user?._id, name: user?.name } }) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function saveCampaign(payload) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'saveCampaign';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ ...payload, user: { _id: user?._id, name: user?.name } }) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function importSynopsis(payload) {

  try {
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'importSynopsis';

    console.log(FINALURL)

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function importCastAndCrew(payload) {

  try {
    const FINALURL = DATAMIGRATIONURL().BASEURL + 'importCastAndCrew';

    console.log(FINALURL)

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}


export async function exportScheduleMusicQSheet(payload) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    var finalPayload = {
      ...payload,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    const FINALURL = SCHEDULINGURL().BASEURL + 'exportScheduleMusicQSheet';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalPayload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function uploadAndProcessITXML(file, channelSID) {

  utility.checkSessionExpire();

  try {

    let FINALURL = SCHEDULINGURL().BASEURL + 'uploadAndProcessITXML';

    let formData = new FormData()
    formData.append('file', file)
    formData.append('channelSID', channelSID)

    let Finalinit = { ...GetHeader("POST", true), "body": formData };

    let response = await fetch(FINALURL, Finalinit);

    let responseData = await response.json();
    return responseData;
  }
  catch (error) {
    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    return { success: false, message: error.message, error: error };
  }

}

export async function getVersionBrowser(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + "getVersionBrowser";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function nodeAttachOffersLink(payload) {
  console.log(payload);

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const finalData = { ...payload, user: { _id: user?._id ?? "", name: user?.name ?? "" } }
    const FINALURL = MEDIAURL().BASEURL + "nodeAttachOffersLink";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getNodeOfferLink(payload) {
  console.log(payload);

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + "getNodeOfferLink";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function updateTransmissionNode(payload) {
  console.log(payload);

  utility.checkSessionExpire();

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);

    const finalData = {
      data: payload,
      user: { _id: user?._id, name: user?.name }
    }
    const FINALURL = MEDIAURL().BASEURL + "updateTransmissionNode";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function syncMAMFromS3() {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    var finalPayload = {
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    const FINALURL = MAMASSETURL().BASEURL + 'syncMAMFromS3';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalPayload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function resyncHeadersWithNoSegments(headers) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    var finalPayload = {
      data: headers,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    const FINALURL = SCHEDULINGURL().BASEURL + 'resyncHeadersWithNoSegments';

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalPayload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPlanningBrowser(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = PLANNINGURL().BASEURL + 'getPlanningBrowser';
    let Finalinit = { ...GetHeader("POST"), body: JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error };
  }
}

export async function saveSeasonEpisodeWorkingTitle(seasonId) {

  utility.checkSessionExpire();

  try {
    const FINALURL = MEDIAURL().BASEURL + 'saveSeasonEpisodeWorkingTitle';
    let Finalinit = { ...GetHeader("POST"), body: JSON.stringify({ seasonId: seasonId }) };
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error };
  }
}

export async function createTransmissionOffer(payload) {

  utility.checkSessionExpire();

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);

    const FINALURL = VOD_URL().BASEURL + 'createTransmissionOffer';
    let Finalinit = { ...GetHeader("POST"), body: JSON.stringify({ ...payload, user: { _id: user?._id, name: user?.name } }) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    return responseData;

  } catch (error) {
    return { success: false, message: error.message, error };
  }
}

export async function exportCampaignSchedule(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = BOOKINGURL().BASEURL + 'exportCampaignSchedule';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function searchDeepArchive(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = DEEPARCHIVE_URL().BASEURL + 'search';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function syncDeepArchive() {

  utility.checkSessionExpire();

  try {
    const FINALURL = DEEPARCHIVE_URL().BASEURL + 'sync';
    let Finalinit = { ...GetHeader("POST") };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getDeepArchiveFolders() {

  utility.checkSessionExpire();

  try {
    const FINALURL = DEEPARCHIVE_URL().BASEURL + 'folders';
    let Finalinit = { ...GetHeader("POST") };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function importLongFormWONStarhubDataViaXML(payload) {

  utility.checkSessionExpire();

  try {
    const FINALURL = STARHUB_MIGRATION_URL().BASEURL + 'importLongFormWONStarhubDataViaXML';
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);

    const responseData = await response.json();
    if (responseData.success) return responseData
    else return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function updateL2VEvent(selectedPlannedEvents) {

  try {
    let FINALURL = STARHUB_IMPORT_URL().BASEURL + 'callUpdateLiveToVodEvent';
    let finalData = {
      data: selectedPlannedEvents
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function RemoveStartAndEndCredits(payload) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      ...payload
    }
    const FINALURL = PLANNINGURL().BASEURL + 'deleteOpenEndCreditsByHeader'

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function saveNode(saveData) {

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = VOD_URL().BASEURL + "saveNode";

    //prepare data
    const finalData = {
      data: saveData,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }
    return responseData;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportPromotionReport(payload) {
  try {
    const FINALURL = REPORTSURL().BASEURL + 'exportPromotionReport'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    if (data.length < 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
      return false;
    }
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getRecursivePlan(RecursionParentProgramSchedule_id) {

  utility.checkSessionExpire();

  try {
    let finalData = {
      RecursionParentProgramSchedule_id: RecursionParentProgramSchedule_id
    }
    const FINALURL = PLANNINGURL().BASEURL + 'getRecursivePlan'

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function createAndUpdateDealRights(dealRights, media_id, isFromContract = false) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let finalData = {
      data: dealRights,
      media_id: media_id,
      isFromContract: isFromContract,
      user: { _id: user?._id ?? "", name: user?.name ?? "", roletypeid: user?.RoleType?.ID ?? ROLETYPE.Admin }
    }
    let FINALURL = CONTRACTURL().BASEURL + 'createAndUpdateDealRights';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function deleteDealRights(dealRightsIds, isFromContract = false) {

  utility.checkSessionExpire();

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  try {
    let finalData = {
      data: dealRightsIds,
      isFromContract: isFromContract,
      user: { _id: user?._id ?? "", name: user?.name ?? "", roletypeid: user?.RoleType?.ID ?? ROLETYPE.Admin }
    }
    let FINALURL = CONTRACTURL().BASEURL + 'deleteDealRights';
    let Finalinit = { ...GetHeader('DELETE'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }


}

export async function deleteNode(nodeId, action) {

  utility.checkSessionExpire();

  try {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const FINALURL = VOD_URL().BASEURL + "deleteNode";

    //prepare data
    const finalData = {
      nodeId: nodeId,
      action: action,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();

    console.log('Saved data response');
    console.log(responseData);
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }
    return responseData;

  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function attachContractWithDealRights(contractId, dealRightsIds) {

  utility.checkSessionExpire();

  try {

    const user = utility.getValue(LOCALSTORAGE_KEY.userData)
    let finalData = {
      contractId: contractId,
      dealRightsIds: dealRightsIds,
      user: { _id: user?._id ?? "", name: user?.name ?? "", roletypeid: user?.RoleType?.ID ?? ROLETYPE.Admin }
    }
    let FINALURL = CONTRACTURL().BASEURL + 'attachContractWithDealRights';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function createAndUpdateAttachMedias(attachMedias) {
  const user = utility.getValue(LOCALSTORAGE_KEY.userData)
  try {
    let finalData = {
      data: attachMedias,
      user: { _id: user?._id ?? "", name: user?.name ?? "" }
    }
    const FINALURL = MEDIAURL().BASEURL + 'createAndUpdateAttachMedias'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function deleteAttachedMedias({ query }) {
  const user = utility.getValue(LOCALSTORAGE_KEY.userData)
  try {
    let finalData = {
      query: query,
      user: user?._id ? { _id: user?._id, name: user?.name } : {}
    }
    const FINALURL = MEDIAURL().BASEURL + 'deleteAttachedMedias'
    let Finalinit = { ...GetHeader('DELETE'), "body": JSON.stringify(finalData) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getLogBrowserData(entityname, args = defaultArgs, columns, searchText, filters) {

  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,
      archive: args.archive || defaultArgs.archive,
      dataColumns: columns || [],
      searchText: searchText || '',
      filters: filters
    };

    if (entityname == ENTITYNAME.Users) {
      const user = utility.getValue(LOCALSTORAGE_KEY.userData);
      if (user && user.RoleType) {
        finalData.query = [...finalData.query, ["RoleType.ID", ">=", user.RoleType.ID]]
      }
    }

    let Finalinit = { ...GetHeader("POST", false), "body": JSON.stringify(finalData) };
    const FINALURL = LOGGERURL().BASEURL + 'getLogBrowserData/' + entityname;

    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();

    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getProgramLastAiringReport(payload) {
  utility.checkSessionExpire();
  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getProgramLastAiringReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMediaActualDurationReport(payload) {
  utility.checkSessionExpire();
  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getMediaActualDurationReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getImportExportDashboardDataCount(payload) {
  const user = utility.getValue(LOCALSTORAGE_KEY.userData)
  try {
    let FINALDATA = {
      ...payload,
      userID: user?._id
    }
    let FINALURL = LOGGERURL().BASEURL + 'getImportExportDashboardDataCount';

    let Finalinit = { ...GetHeader("POST", false, true), "body": JSON.stringify(FINALDATA) };
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getVodMasterTrackerReport(payload) {

  utility.checkSessionExpire();

  try {

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };
    const FINALURL = REPORTSURL().BASEURL + 'getVodMasterTrackerReport';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function publishSocialMediaPromotionPosts(payload) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'publishSocialMediaPromotionPosts';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function unpublishSocialMediaPromotionPosts(payload) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'unpublishSocialMediaPromotionPosts';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function getSocialMediaPromotionPostInsights(payload) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getSocialMediaPromotionPostInsights';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function assignNewTransmissionIds(programScheduleIds) {

  try {
    let FINALURL = LIVETOVOD_URL().BASEURL + 'assignNewTransmissionIds';
    let finalData = {
      programScheduleIds: programScheduleIds
    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) }
    let response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();
    return responseData;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function checkPlanningOverlapOrGap(payload) {
  try {
    const FINALURL = PLANNINGURL().BASEURL + 'checkPlanningOverlapOrGap';
    let bodyData = payload?.payload ? payload : { payload: payload };
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(bodyData) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMediaEpisodeReport(payload) {
  try {
    const FINALURL = REPORTSURL().BASEURL + 'getMediaEpisodeReport';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function exportUbsUrfReport(payload) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  let finalData = {
    ...payload,
    User: { _id: user?._id, name: user?.name, SID: user?.SID }
  }

  try {
    const FINALURL = REPORTSURL().BASEURL + 'exportUbsUrfReport';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(finalData) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPromotionPostFromCampaign(payload) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'getPromotionPostFromCampaign';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error }
  }
}

export async function exportPromotionRevenueReport(payload) {
  try {
    let FINALURL = SOCIAL_MEDIA_URL().BASEURL + 'exportPromotionRevenueReport';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function createSeriesTransmission(payload) {

  try {

    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const finalData = {
      ...payload,
      user: { _id: user?._id, name: user?.name }
    }

    const FINALURL = MEDIAURL().BASEURL + "createSeriesTransmission";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getVersionFromSeries(payload) {

  try {

    const FINALURL = MEDIAURL().BASEURL + "getVersionFromSeries";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(payload) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    if (!responseData.success) {
      utility.checkTokenExpire(responseData);
    }

    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function getMediaEpisodeFromMamIds(payload) {
  try {
    const FINALURL = MEDIAURL().BASEURL + 'getMediaEpisodeFromMamIds';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}

export async function getVodActivityReport(payload) {

  const user = utility.getValue(LOCALSTORAGE_KEY.userData)

  let finalData = {
    ...payload,
    User: { _id: user?._id, name: user?.name }
  }

  try {
    const FINALURL = MEDIAURL().BASEURL + "getVodActivityReport";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    return responseData;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }

}

export async function splitSegments(programScheduleId, splitDuration) {

  utility.checkSessionExpire();

  try {
    let payload = {
      programScheduleId: programScheduleId,
      splitDuration: splitDuration
    }
    const FINALURL = SCHEDULINGURL().BASEURL + 'splitSegments'
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) }
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;

  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}